import React, { useState } from "react";
import MenuBar from "../components/menuBarLoggedIn/menuBarLoggedInNoNavbar";
import TicketOptions from "./TicketOptionsPage";
import PassengerDetails from "./PassengerDetailsPage";
import ReviewAndPay from "./ReviewAndPayPage";

import rightChevron from "../assets/svgs/chevron-right.svg"
import "../styles/TicketOptionPage.css";

const TicketOption = () => {
  const [child1Visible, setChild1Visible] = useState(true);
  const [child2Visible, setChild2Visible] = useState(false);
  const [child3Visible, setChild3Visible] = useState(false);

  const toggleChild1Visibility = () => {
    if (!child1Visible) {
      setChild1Visible(!child1Visible);
      setChild2Visible(false);
      setChild3Visible(false);
    }
  };
  
  const toggleChild2Visibility = () => {
    if (!child2Visible) {
      setChild1Visible(false);
      setChild2Visible(!child2Visible);
    setChild3Visible(false);
    }
  };
  
  const toggleChild3Visibility = () => {
    if (!child3Visible) {
    setChild1Visible(false);
    setChild2Visible(false);
    setChild3Visible(!child3Visible);
    }
  };
    return (
        <>
          <MenuBar/>
          <header className="ticket-option-pages">
            <div className="ticket-option-pages-wrapper">
              <button className="ticket-option" onClick={toggleChild1Visibility}>
                {child1Visible && <p style={{color: "#FFFFFF", fontSize: "1.3125rem"}}>Ticket options</p>}
                {child1Visible && <img src={rightChevron} alt="" style={{filter: "brightness(0) saturate(100%) invert(100%)"}}/>}
                {!child1Visible && <p style={{color: "#FFFFFFCC"}}>Ticket Options</p> }
                {!child1Visible && <img src={rightChevron} alt="" style={{filter: "brightness(0) saturate(100%) invert(100%)", opacity:"0.8"}}/>}
              </button>
              <button className="ticket-option" onClick={toggleChild2Visibility}>
                {child2Visible && <p style={{color: "#FFFFFF"}}>Passenger Details</p>}
                {child2Visible && <img src={rightChevron} alt="" style={{filter: "brightness(0) saturate(100%) invert(100%)", fontSize: "1.3125rem"}}/>}
                {!child2Visible && <p style={{color: "#FFFFFFCC"}}>Passenger Details</p> }
                {!child2Visible && <img src={rightChevron} alt="" style={{filter: "brightness(0) saturate(100%) invert(100%)", opacity:"0.8"}}/>}
                {/* <img src={rightChevron} alt="" /> */}
              </button>
              <button className="ticket-option" onClick={toggleChild3Visibility}>
                {child3Visible && <p style={{color: "#FFFFFF", fontSize: "1.3125rem"}}>Review and pay</p>}
                {!child3Visible && <p style={{color: "#FFFFFFCC"}}>Review and pay</p>}
              </button>
            </div>
          </header>
          <main className="ticket-option-content">
          {child1Visible && <TicketOptions />}
          {child2Visible && <PassengerDetails />}
          {child3Visible && <ReviewAndPay />}
            {/* <TicketOptions /> */}
            {/* <PassengerDetails /> */}
            {/* <ReviewAndPay /> */}
          </main>
        </>
    );
}
export default TicketOption;